import React, { useState, useEffect, useMemo } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Box,
	Typography,
	TextField,
} from "@mui/material";
import moment from "moment";
import PATCloseButton from "../../components/Buttons/PATCloseButton";
import PATSaveButton from "../../components/Buttons/PATSaveButton";

const CloseWorkOrderDialog = ({
	open,
	onClose,
	onConfirm,
	workOrder,
	vehicleStatusOptions = [],
	vehicleOptions = [],
}) => {
	const [closedDate, setClosedDate] = useState(moment());
	const [newVehicleStatus, setNewVehicleStatus] = useState("");
	const [odometerAtService, setOdometerAtService] = useState("");

	const selectedVehicle = useMemo(
		() =>
			vehicleOptions.find(
				(v) => v.value === Number(workOrder?.vehicleId),
			),
		[vehicleOptions, workOrder?.vehicleId],
	);

	// Reset state when dialog opens
	useEffect(() => {
		if (open) {
			setClosedDate(moment());
			setNewVehicleStatus("");
			setOdometerAtService(workOrder?.odometerAtService || "");
		}
	}, [open, workOrder]);

	const handleConfirm = () => {
		onConfirm(
			closedDate
				? closedDate.format("YYYY-MM-DD")
				: moment().format("YYYY-MM-DD"),
			newVehicleStatus || null,
			odometerAtService ? Number(odometerAtService) : null,
		);
	};

	if (!workOrder) return null;

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
			<DialogTitle>Close Work Order</DialogTitle>

			<DialogContent sx={{ pt: 2, mt: 2 }}>
				<Typography variant="body2" sx={{ mb: 3 }}>
					You are about to close work order{" "}
					<strong>
						WO-{String(workOrder.id).slice(-4).padStart(4, "0")}
					</strong>
					.
				</Typography>

				<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
					<Typography variant="body2" color="text.secondary">
						Current:{" "}
						<strong
							style={{
								color:
									selectedVehicle.status === "Out of Service"
										? "#ef4444"
										: selectedVehicle.status ===
											  "Maintenance"
											? "#f59e0b"
											: "#22c55e",
								marginLeft: "0.5ch",
							}}
						>
							{selectedVehicle.status || "Unknown"}
						</strong>
					</Typography>
					<TextField
						select
						label="Update Vehicle Status"
						name="newVehicleStatus"
						onChange={(e) => setNewVehicleStatus(e.target.value)}
						fullWidth
						size="small"
						InputLabelProps={{ shrink: true }}
						SelectProps={{ native: true }}
					>
						<option value="">— No Change —</option>
						{vehicleStatusOptions.map((status) => (
							<option
								key={status.value || status}
								value={status.value || status}
							>
								{status.label || status}
							</option>
						))}
					</TextField>
				</Box>
			</DialogContent>

			<DialogActions sx={{ px: 3, pb: 2 }}>
				<PATCloseButton onClick={onClose} tooltipText="Cancel" />
				<PATSaveButton
					onClick={handleConfirm}
					tooltipText="Close Work Order"
				/>
			</DialogActions>
		</Dialog>
	);
};

export default CloseWorkOrderDialog;
